import {
  selectAsideCollapsed,
  selectAsideToggled,
  setAsideCollapsed,
  setAsideToggled,
} from "app/modules/navigation/aside/AsideMenuSlice";
import { useMediaLayout } from "cpl-react-common/Hooks/useMediaQuery";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const useAsideMenu = () => {
  const dispatch = useDispatch();
  const { isMobile, isTablet } = useMediaLayout();
  const asideToggled = useSelector(selectAsideToggled);
  const asideCollapsed = useSelector(selectAsideCollapsed);

  useEffect(() => {
    dispatch(setAsideToggled(!isMobile));
  }, [dispatch, isMobile]);

  useEffect(() => {
    dispatch(setAsideCollapsed(isTablet));
  }, [dispatch, isTablet]);

  const setAsideMenuCollapsed = (collapsed: boolean) => {
    dispatch(setAsideCollapsed(collapsed));
  };

  const setAsideMenuToggled = (toggled: boolean) => {
    dispatch(setAsideToggled(toggled));
  };

  return { asideToggled, asideCollapsed, setAsideMenuToggled, setAsideMenuCollapsed };
};

export default useAsideMenu;
